import { render, staticRenderFns } from "./add-extend-area.vue?vue&type=template&id=033b1642&"
import script from "./add-extend-area.vue?vue&type=script&lang=js&"
export * from "./add-extend-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports